import { IFieldVisibilityContext, ITemplate, ITemplateComponent } from "entities/template";

export const buildFieldVisibilityContext = (
    formRecord: Record<string, any>,
    components: ITemplateComponent[],
    template: ITemplate,
    enLanguageEnabled: boolean,
    language: string,
    isExternalUser: boolean,
): IFieldVisibilityContext => ({
    formRecord,
    components,
    template,
    enLanguageEnabled,
    language,
    isExternalUser,
});
